import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { user, logout, isAdmin, isSchoolAdmin, isDistrict } = useAuth();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-light-bg flex">
      <Sidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        currentPath={location.pathname}
        isAdmin={isAdmin}
        isSchoolAdmin={isSchoolAdmin}
        isDistrict={isDistrict}
        user={user}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header
          user={user}
          onLogout={handleLogout}
          toggleSidebar={toggleSidebar}
        />

        <main className="flex-1 overflow-y-auto bg-light-bg p-6">
          {children}
        </main>

        <footer className="bg-white border-t border-gray-200 py-4 px-6">
          <p className="text-center text-sm text-gray-500">
            Read21 Portal © {new Date().getFullYear()} - All Rights Reserved
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Layout;






